import { ComposableMap, Geographies, Geography, Marker, Annotation } from "react-simple-maps";

const geoUrl = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

const ORIGIN = { lon: 32.58, lat: 1.37, label: "UGANDA · ORIGIN" };
const DESTS = [
  { lon: -0.13, lat: 51.51, label: "UNITED KINGDOM" },
  { lon: 8.68, lat: 50.11, label: "GERMANY" },
  { lon: 4.35, lat: 50.85, label: "EU" },
  { lon: 35.21, lat: 31.77, label: "ISRAEL" },
  { lon: 134.49, lat: -25.73, label: "AUSTRALIA" },
  { lon: -106.34, lat: 56.13, label: "CANADA" },
];

const HIGHLIGHT = new Set(["826", "276", "056", "528", "250", "380", "724", "620", "372", "208", "752", "616", "203", "703", "642", "100", "300", "470", "807", "705", "036", "124", "376"]);

/**
 * WorldMap — institutional world map for Global Market Focus section.
 * Highlights European destination markets and the Uganda origin.
 */
export const WorldMap = ({ darkMode = false }) => {
  const baseFill = darkMode ? "rgba(247,246,242,0.06)" : "rgba(12,59,51,0.06)";
  const highlightFill = darkMode ? "rgba(199,116,78,0.22)" : "rgba(199,116,78,0.18)";
  const stroke = darkMode ? "rgba(247,246,242,0.18)" : "rgba(12,59,51,0.22)";
  const labelColor = darkMode ? "#F7F6F2" : "#1D1D1B";
  const subColor = darkMode ? "rgba(247,246,242,0.7)" : "#5C615E";

  return (
    <div data-testid="world-map" className="relative">
      <ComposableMap
        projection="geoEqualEarth"
        projectionConfig={{ scale: 175, center: [10, 20] }}
        width={1000}
        height={520}
        style={{ width: "100%", height: "auto" }}
      >
        <Geographies geography={geoUrl}>
          {({ geographies, projection }) => {
            const o = projection([ORIGIN.lon, ORIGIN.lat]);
            return (
              <>
                {geographies.map((geo) => {
                  const isHighlighted = HIGHLIGHT.has(geo.id);
                  const isOrigin = geo.id === "800";
                  return (
                    <Geography
                      key={geo.rsmKey}
                      geography={geo}
                      style={{
                        default: {
                          fill: isOrigin ? "#0C3B33" : isHighlighted ? highlightFill : baseFill,
                          stroke,
                          strokeWidth: 0.4,
                          outline: "none",
                        },
                        hover: { outline: "none" },
                        pressed: { outline: "none" },
                      }}
                    />
                  );
                })}
                {o && DESTS.map((d, i) => {
                  const p = projection([d.lon, d.lat]);
                  if (!p) return null;
                  const mx = (o[0] + p[0]) / 2;
                  const my = Math.min(o[1], p[1]) - 90 - i * 14;
                  return (
                    <path
                      key={d.label}
                      d={`M${o[0]},${o[1]} Q${mx},${my} ${p[0]},${p[1]}`}
                      fill="none"
                      stroke="#C7744E"
                      strokeWidth="1.4"
                      className="route-line"
                    />
                  );
                })}
              </>
            );
          }}
        </Geographies>

        <Marker coordinates={[ORIGIN.lon, ORIGIN.lat]}>
          <circle r={11} fill="none" stroke="#0C3B33" strokeOpacity="0.4" strokeWidth="1">
            <animate attributeName="r" values="11;24;11" dur="3.4s" repeatCount="indefinite" />
            <animate attributeName="stroke-opacity" values="0.45;0;0.45" dur="3.4s" repeatCount="indefinite" />
          </circle>
          <circle r={5} fill="#0C3B33" />
          <text x={10} y={4} fontFamily="Manrope" fontSize={10} fill={labelColor} letterSpacing={1.6}>
            {ORIGIN.label}
          </text>
        </Marker>

        {DESTS.map((d, i) => (
          <Marker key={d.label} coordinates={[d.lon, d.lat]}>
            <circle r={8} fill="none" stroke="#C7744E" strokeOpacity="0.5" strokeWidth="0.9">
              <animate attributeName="r" values="8;16;8" dur="3.6s" begin={`${i * 0.5}s`} repeatCount="indefinite" />
              <animate attributeName="stroke-opacity" values="0.55;0;0.55" dur="3.6s" begin={`${i * 0.5}s`} repeatCount="indefinite" />
            </circle>
            <circle r={4} fill="#C7744E" />
            <text x={-6} y={-12} fontFamily="Manrope" fontSize={9.5} fill={subColor} letterSpacing={1.5}>
              {d.label}
            </text>
          </Marker>
        ))}
      </ComposableMap>
    </div>
  );
};

export default WorldMap;
